import React from 'react';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';

import {
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow,
  TableRowColumn,
} from 'material-ui/Table';



class CircuitsFormulas extends React.Component{

  render(){
    return(
      <MuiThemeProvider>

        <div style = {{paddingBottom: 40}}>

        <Table>
    <TableHeader>
      <TableRow>
        <TableHeaderColumn style = {{width: 450}}>Uses</TableHeaderColumn>
        <TableHeaderColumn>Formula</TableHeaderColumn>
      </TableRow>
    </TableHeader>
    <TableBody>
      <TableRow>
        <TableRowColumn style = {{width: 400}}>Current</TableRowColumn>
        <TableRowColumn> <img style = {{paddingRight: 100}} src = {require("./Formulas/1.png")} /> </TableRowColumn>
      </TableRow>
      <TableRow>
        <TableRowColumn style = {{width: 400}}>Resistance</TableRowColumn>
        <TableRowColumn><img style = {{paddingRight: 100}} src = {require("./Formulas/2.png")} /></TableRowColumn>
      </TableRow>
      <TableRow>
        <TableRowColumn style = {{width: 400}}>Ohm's Law</TableRowColumn>
        <TableRowColumn><img style = {{paddingRight: 100}} src = {require("./Formulas/3.png")} /></TableRowColumn>
      </TableRow>
      <TableRow>
        <TableRowColumn style = {{width: 400}}>Voltage (series)</TableRowColumn>
        <TableRowColumn><img style = {{paddingRight: 100}} src = {require("./Formulas/4.png")} /></TableRowColumn>
      </TableRow>
      <TableRow>
        <TableRowColumn style = {{width: 400}}>Voltage (parallel)</TableRowColumn>
        <TableRowColumn><img style = {{paddingRight: 100}} src = {require("./Formulas/5.png")} /></TableRowColumn>
      </TableRow>
      <TableRow>
        <TableRowColumn style = {{width: 400}}>Resistance (series)</TableRowColumn>
        <TableRowColumn> <img style = {{paddingRight: 100}} src = {require("./Formulas/6.png")} /> </TableRowColumn>
      </TableRow>
      <TableRow>
        <TableRowColumn style = {{width: 400}}>Resistance (parallel)</TableRowColumn>
        <TableRowColumn><img style = {{paddingRight: 100}} src = {require("./Formulas/7.png")} /></TableRowColumn>
      </TableRow>
      <TableRow>
        <TableRowColumn style = {{width: 400}}>Capacitors (series)</TableRowColumn>
        <TableRowColumn><img style = {{paddingRight: 100}} src = {require("./Formulas/8.png")} /></TableRowColumn>
      </TableRow>
      <TableRow>
        <TableRowColumn style = {{width: 400}}>Capacitors (parallel)</TableRowColumn>
        <TableRowColumn><img style = {{paddingRight: 100}} src = {require("./Formulas/9.png")} /></TableRowColumn>
      </TableRow>
      <TableRow>
        <TableRowColumn style = {{width: 400}}>Capacitance</TableRowColumn>
        <TableRowColumn><img style = {{paddingRight: 100}} src = {require("./Formulas/10.png")} /></TableRowColumn>
      </TableRow>
      <TableRow>
        <TableRowColumn style = {{width: 400}}>Electric Field in Capacitor</TableRowColumn>
        <TableRowColumn> <img style = {{paddingRight: 100}} src = {require("./Formulas/11.png")} /> </TableRowColumn>
      </TableRow>
      <TableRow>
        <TableRowColumn style = {{width: 400}}>Potential Energy (capacitor)</TableRowColumn>
        <TableRowColumn><img style = {{paddingRight: 100}} src = {require("./Formulas/12.png")} /></TableRowColumn>
      </TableRow>
      <TableRow>
        <TableRowColumn style = {{width: 400}}>Capacitance (with dielectric material)</TableRowColumn>
        <TableRowColumn><img style = {{paddingRight: 100}} src = {require("./Formulas/13.png")} /></TableRowColumn>
      </TableRow>
      <TableRow>
        <TableRowColumn style = {{width: 400}}>Electric Power</TableRowColumn>
        <TableRowColumn><img style = {{paddingRight: 100}} src = {require("./Formulas/14.png")} /></TableRowColumn>
      </TableRow>
      <TableRow>
        <TableRowColumn style = {{width: 400}}>Power</TableRowColumn>
        <TableRowColumn><img style = {{paddingRight: 100}} src = {require("./Formulas/15.png")} /></TableRowColumn>
      </TableRow>
    </TableBody>
  </Table>

</div>

      </MuiThemeProvider>

    );
  }
}

export default CircuitsFormulas;



// WEBPACK FOOTER //
// ./src/Physics/Circuits/CircuitsFormulas.js